import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** 1C ERP database connection credentials base data */
export interface Connection1cCredentialsInterface {
  /** 1C ERP user login */
  login: string;
  /** 1C ERP user password */
  password: string;
  /** 1C ERP database internal name */
  database: string;
  /** 1C ERP database address (domain name or IP-address) */
  host: string;
  /** If `true` then `https://` protocol will be used instead of `http://` */
  secure?: boolean;
}

/** 1C ERP database connection credentials base data - DTO schema */
export const Connection1cCredentialsDto = SerdeDtoClass.create<Connection1cCredentialsInterface>(IntergrationDtoKeyEnum.CONNECTION_1C_CREDENTIALS_DTO, {
  login: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  password: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  database: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  host: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  secure: {
    optional: true,
    default: false,
    label: 'Безопасное соединение',
    serializer: yup.boolean(),
  },
});
